<section class="entry-panel">
  <h2 class="entry-title">{{entryData?.title}}</h2>
  <p class="entry-subtitle">{{entryData?.subTitle}}</p>
  <ng-container *ngFor="let interaction of entryData?.formattedDescription">
    <p class="entry-system-content">
      {{interaction}}
    </p>
  </ng-container>
</section>
